import React, { useState } from "react";
import "../Pages/stylenews.css";
import { Container, Row, Col } from "react-bootstrap";
import { useEffect } from "react";
import { axiosGet, baseURL } from "../Store/Actions";
import Breadcrumb from "../component/Breadcrumb";
import { useParams } from "react-router-dom";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';

function NewsContent() {
  const { id } = useParams()
  const [news, setNews] = useState([])

  const getNews = async () => {
    await axiosGet(`news-content/${id}`).then((res) => {
      setNews(res[0].data[0]);
    });
  };

  useEffect(() => {
    getNews();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const dateFormat = (input) => {
    const date = new Date(input);

    // Opsi 1: Gunakan toLocaleDateString (cara paling mudah)
    const formatted = date.toLocaleDateString("id-ID", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    return formatted;
  }

  return (
    <div className="NewsContent">
      <style>
        {`
          .news-content img {
            max-width: 100%;
            height: auto;
            display: block;
          }
          .ck.ck-editor__top.ck-reset_all {
            display: none !important;
          }
          .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
            border: none !important;
            padding: unset !important;
          }
        `}
      </style>
      <Breadcrumb
        customValue={['news', `${news.title?.substring(0, 100)}...`]}
      />
      <Container fluid>
        <Row style={{ alignItems: "center", marginBottom: "40px" }}>
          <Col style={{
            color: "#BE1620",
            cursor: "pointer",
            fontFamily: "Poppins",
            fontWeight: "600"
          }} onClick={() => window.location.href = `/news`}>{'< Back'}</Col>
          <Col className="DefaultTitlePage" style={{ marginBottom: "0px" }}>NEWS DETAILS</Col>
          <Col><div></div></Col>
        </Row>
        {news?.image_news !== null && (
          <Col sm={12} style={{ marginBottom: "50px" }}>
            <img src={`${baseURL}/${news?.image_news}`} alt={`NewsImage.png`} style={{
              width: "100%", height: "500px", objectFit: "cover",        // agar proporsi tetap & gambar ter-crop
              objectPosition: "center", borderRadius: "20px"
            }} />
          </Col>
        )}
        <Col sm={12} style={{ marginBottom: "30px" }}>
          <div style={{ fontFamily: "Poppins", fontSize: "20px", fontWeight: "700", marginTop: "15px", lineHeight: "1.3" }} >{news.title}</div>
        </Col>
        <Col sm={12} style={{ marginBottom: "30px" }}>
          <div style={{ width: "fit-content", fontSize: "14px", fontWeight: "500", backgroundColor: "#F4F4F4", padding: "5px 10px", borderRadius: "5px" }}>{dateFormat(news.createdAt)}</div>
        </Col>
        <Col sm={12} style={{ marginBottom: "80px" }}>
          {/* <div className="news-content ck-content"
            dangerouslySetInnerHTML={{ __html: news?.content }}
          /> */}

          <CKEditor
            editor={Editor}
            data={!news?.content ? "" : news?.content}
            onBlur={(event, editor) => { console.log('Blur.', editor); }}
            onFocus={(event, editor) => { console.log('Focus.', editor); }}
            config={{
              toolbar: []
            }}
            disabled={true}
          />

        </Col>
      </Container>
    </div >
  );
}
export default NewsContent;
